export default __webpack_public_path__ + "static/media/adventure-activity.80c3d17d.svg";